import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Input, ScannerCode, Title } from '../../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../../utils/constants';
import { convertToUppercase, isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';

const ConfirmationAllocation = (props) => {
    const dataParams = props.history?.location?.state?.dataParams;
    const [openModal, setOpenModal] = useState(false);
    const [messageModal, setMessageModal] = useState({ task: false, message: '' });
    const [filter, setFilter] = useState({
        partNumber: dataParams?.partNumber || '',
        area: dataParams?.area || '',
        barCode: dataParams?.cim,
        print: 'N',
        resourceId: '',
        location: ''
    });


    useEffect(() => {
        let filterState = filter;
        setFilter(filterState);
        // eslint-disable-next-line
    }, [])

    const closeModal = () => {
        setOpenModal(false);
        messageModal.task = false;
        messageModal.message = '';
        setMessageModal({ ...messageModal });
        if (messageModal.task) {
            props.history.go(-1);
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeToUpper = (event) => {
        convertToUppercase(event)
        onValueChange(event, filter, setFilter);
    }

    const scannerLocation = (value) => {
        if (!isNullOrEmpty(value)) {
            filter.location = value;
            props.setFilter({ ...filter });
        }
    }

    const setResource = () => {
        if (filter.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const validateResource = () => {
        if (!props.user?.resourceObj && filter.print !== ENUMS.ePrintTypes.NotPrint.value) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    const validateLocation = () => {
        if (dataParams.locationTarget !== filter.location) {
            showMessageToastCustom(translate('warning', 'general'), translate('stock:validation-location-allocation'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }



    const confirm = () => {
        if (validateInputsRequired('formInput') && validateResource() && validateLocation()) {
            var filterobj = {};
            Object.assign(filterobj, filter);
            filterobj.resource = setResource();
            filterobj.printer = props.user.printer;
            filterobj.task = dataParams.task;
            props.confirm(
                filterobj,
                () => {
                    showMessageToastCustom(translate('general.info'), translate('sucess', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);

                },
                (message, task) => {
                    messageModal.task = task;
                    messageModal.message = message
                    setMessageModal({ ...messageModal });
                    setOpenModal(true);
                }

            );
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('stock:allocation-confirmation')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card" >
                        <div id="formInput" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div style={{ marginLeft: '5px' }} >
                                <div className="input-field col s11 no-padding m6" style={{ marginBottom: '30px' }}>
                                    <span className="truncate second-text-color">
                                        {translate('stock:partnumber')}: {dataParams.partNumberCode} - {dataParams.partNumberDescription}
                                    </span>
                                    <span className="truncate second-text-color">
                                        {translate('stock:origin')}: {dataParams.location}
                                    </span>
                                    <span className="truncate second-text-color">
                                        {translate('stock:target')}: {dataParams.locationTarget}
                                    </span>
                                </div>
                                <div className="input-field col s11 no-padding m6">
                                    <Input
                                        disabled={true}
                                        required
                                        label={translate('stock:cim')}
                                        id="barCode"
                                        name="barCode"
                                        type="text"
                                        maxLength={10}
                                        onChange={onChangeToUpper}
                                        defaultValue={filter?.barCode}
                                    />
                                </div>
                                <div className="input-field col s11 no-padding m5" >
                                    <Input
                                        required
                                        label={translate('location', 'change-location')}
                                        id="location"
                                        name="location"
                                        type="text"
                                        onChange={onChange}
                                        defaultValue={filter?.location}
                                    />
                                    <ScannerCode onScanner={scannerLocation} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button
                                onClick={() => confirm()}
                                text={translate('confirm', 'general')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModalUI
                open={openModal}
                id="messageModalErro"
                data={{
                    title: translate('validations:attention'), message: <>
                        <span className="title col s12" style={{ color: 'red' }}>{
                            messageModal.message}</span>
                    </>
                }}
                showCancel={false}
                onConfirm={closeModal}
                onClose={closeModal}
                btnConfirm={translate('close', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirm: (model, callback) => {
            dispatch(ChangeLocationService.confirmationAllocation(model, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmationAllocation));